// Locale resolution — the SAME contract as the inline pre-paint script in
// index.html: stored choice ('parsina.locale') → Persian. Keep the two in step.
//
// THE DEVICE LANGUAGE IS DELIBERATELY NOT CONSULTED, and that is the one place
// this app departs from the doctor client (whose order is stored → device →
// English). This panel is for Iranian medical students; its content, its
// clinical vocabulary and every case a student writes are Persian. Reading the
// browser's language means a student on a laptop that shipped as en-US — which
// is most of them — gets an English shell around Persian content, having asked
// for nothing.
//
// English is not lost, it is just no longer guessed at: SUPPORTED still carries
// it, and the language switcher in the Profile screen selects it explicitly.
// That choice is what STORAGE_KEY holds, and step 1 above still honours it
// outright, so a student who wants English keeps it across every reload.
//
// A deliberately small implementation of that contract: resolution is the only
// part of i18n this app needs that the doctor client's src/i18n/ also has, and
// the rest of that module (namespace-per-file, a lazy loader) buys nothing for
// six screens and one bundle — see catalogs.js. Keep this contract identical to
// the sibling clients' and to the pre-paint script in index.html.

export const SUPPORTED = { fa: 'rtl', en: 'ltr' };
export const STORAGE_KEY = 'parsina.locale';

/** The app's language. Persian is the default, not a fallback reached after a
 *  guess failed — nothing is guessed. See the note at the top of this file. */
export const FALLBACK = 'fa';

/** Narrow any BCP-47-ish tag to a supported locale, or null. */
export function narrow(tag) {
  if (!tag) return null;
  if (SUPPORTED[tag]) return tag;
  const base = String(tag).toLowerCase().split(/[-_]/)[0];
  return SUPPORTED[base] ? base : null;
}

/**
 * Resolve the active locale: an explicit stored choice, otherwise Persian.
 *
 * `languages` is still accepted so every existing caller and test keeps its
 * signature, and so the parameter documents what is deliberately ignored rather
 * than leaving a future reader to wonder whether device detection was forgotten.
 */
export function resolveLocale(storage, _languages) {
  let stored = null;
  try {
    stored = narrow(storage?.getItem(STORAGE_KEY));
  } catch {
    /* storage off */
  }
  return stored || FALLBACK;
}
